import { Injectable } from '@angular/core';

import {
	GetPipelineJobsResponse,
	GetPipelineResponse,
	GetPipelinesResponse,
} from '@reach/interfaces/pipelines/pipeline.responses';

import { BaseApiService } from '~app-client/api/_internal';

@Injectable({ providedIn: 'root' })
export class PipelinesApiService extends BaseApiService {
	protected commonPath = ['pipelines'];

	public async getJobsByPipelineId(id: string): Promise<GetPipelineJobsResponse> {
		const params = {
			t: this.paramTime,
		};
		return await this.http.get<GetPipelineJobsResponse>(this.url(id, 'jobs'), params);
	}

	public async getPipeline(id: string): Promise<GetPipelineResponse> {
		const pipeline = await this.http.get<GetPipelineResponse>(this.url(id));
		return pipeline;
	}

	public async getPipelines(): Promise<GetPipelinesResponse> {
		return await this.http.get<GetPipelinesResponse>(this.url());
	}
}
